import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Card from '../../components/Card/Card';
import Button from '../../components/Button/Button';
import Loading from '../../components/Loading/Loading';
import api from '../../services/api';
import { EventWithShortCode } from '../../types';
import { formatDateRange, getErrorMessage } from '../../utils/helpers';
import './Events.scss';

const Events: React.FC = () => {
  const { user } = useAuth();
  const [events, setEvents] = useState<EventWithShortCode[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchEvents = useCallback(async () => {
    if (!user?.uuid) return;

    try {
      setLoading(true);
      const data = await api.listEvents(user.uuid);
      setEvents(data);
    } catch (err) {
      setError(getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    fetchEvents();
  }, [fetchEvents]);

  if (loading) {
    return <Loading message="Loading events..." />;
  }

  return (
    <div className="events-page">
      <div className="container">
        <div className="events-page__header">
          <h1>My Events</h1>
          <Link to="/events/new">
            <Button>Create Event</Button>
          </Link>
        </div>

        {error && <div className="error-message">{error}</div>}

        {events.length === 0 ? (
          <Card>
            <p className="text-center text-muted">
              No events yet. Create your first event to get started!
            </p>
            <div className="text-center mt-md">
              <Link to="/events/new">
                <Button>Create Event</Button>
              </Link>
            </div>
          </Card>
        ) : (
          <div className="events-grid">
            {events.map((event) => (
              <Link
                key={event.uuid}
                to={`/events/${event.uuid}`}
                className="event-card-link"
              >
                <Card hoverable>
                  <h3>{event.title}</h3>
                  <p className="text-muted">{formatDateRange(event.startDate, event.endDate)}</p>
                  {event.description && (
                    <p className="event-description">{event.description}</p>
                  )}
                  <div className="event-shortcode">
                    Event Code: <strong>{event.shortcode}</strong>
                  </div>
                </Card>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Events;
